
import { Link } from 'react-router-dom';
import { useLanguageMode, bilingual } from '../../i18n/bilingual';

const Footer = () => {
  const { mode } = useLanguageMode();
  const footerLinks = {
    product: [
      { nameDe: 'Funktionen', nameEn: 'Features', href: '#features' },
      { nameDe: 'Preise', nameEn: 'Pricing', href: '/plans' },
      { nameDe: 'NutriBot KI', nameEn: 'NutriBot AI', href: '#nutribot' },
      { nameDe: 'Erfolgsgeschichten', nameEn: 'Success Stories', href: '#testimonials' },
    ],
    company: [
      { nameDe: 'Über uns', nameEn: 'About Us', href: '#about' },
      { nameDe: 'Kontakt', nameEn: 'Contact', href: '#contact' },
      { nameDe: 'Datenschutzerklärung', nameEn: 'Privacy Policy', href: '#privacy' },
      { nameDe: 'Nutzungsbedingungen', nameEn: 'Terms of Use', href: '#terms' },
    ],
    support: [
      { nameDe: 'Hilfe-Center', nameEn: 'Help Center', href: '#help' },
      { nameDe: 'FAQ', nameEn: 'FAQ', href: '#faq' },
      { nameDe: 'Community', nameEn: 'Community', href: '#community' },
      { nameDe: 'API-Dokumentation', nameEn: 'API Documentation', href: '#api' },
    ],
  };

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center mb-4">
              <div className="text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                <span className="text-yellow-400">Dein</span>
                <span className="text-white">Ernährungsplan</span>
              </div>
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {bilingual(
                mode,
                'Verbessern Sie Ihre Gesundheit mit KI‑gestützten, personalisierten Ernährungsplänen. Schließen Sie sich tausenden Menschen an, die ihre Ziele mit unserer intelligenten Plattform erreicht haben.',
                'Improve your health with AI‑powered, personalized meal plans. Join thousands who achieved their goals with our intelligent platform.'
              )}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{bilingual(mode, 'Produkt', 'Product')}</h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm"
                  >
                    {bilingual(mode, link.nameDe, link.nameEn)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{bilingual(mode, 'Unternehmen', 'Company')}</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm"
                  >
                    {bilingual(mode, link.nameDe, link.nameEn)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{bilingual(mode, 'Support', 'Support')}</h3>
            <ul className="space-y-3">
              {footerLinks.support.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm"
                  >
                    {bilingual(mode, link.nameDe, link.nameEn)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              {bilingual(mode, '© 2025 Dein Ernährungsplan. Alle Rechte vorbehalten.', '© 2025 Your Nutrition Plan. All rights reserved.')}
            </p>
            <div className="flex items-center mt-4 md:mt-0">
              <span className="text-gray-400 text-sm mr-2">{bilingual(mode, 'Bereitgestellt von', 'Powered by')}</span>
              <a 
                href="http:olarinreb813@gmail.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-yellow-400 hover:text-yellow-300 transition-colors duration-200 text-sm font-medium"
              >
                Testy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
